import { render, staticRenderFns } from "./detailTabComment.vue?vue&type=template&id=43101192&scoped=true&"
import script from "./detailTabComment.vue?vue&type=script&lang=js&"
export * from "./detailTabComment.vue?vue&type=script&lang=js&"
import style0 from "./detailTabComment.vue?vue&type=style&index=0&id=43101192&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43101192",
  null
  
)

export default component.exports